import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import DupSummary from "../../../components/dup/DupSummary";
import { ClientCheckList } from "../../../components/Shared/ClientChecklist";
import { IbanNumber } from "../../../components/Shared/IbanNumber";
import { Step } from "../../../components/stepIndicator/Step";
import { StepIndicator } from "../../../components/stepIndicator/StepIndicator";
import { scrollToFirstValidationMessage } from "../../../components/validationMessage/scrollToFirstValidationMessage";
import { ValidationMessage } from "../../../components/validationMessage/ValidationMessage";
import { useDidMount } from "../../../hooks/useDidMount";
import { useDupFlowContext } from "../../../hooks/useDupContext";
import { FlowLayout } from "../../FlowLayout";

interface Props {
  fields: Record<string, Field<string> & { url: string }>;
}

export const DupFlowStepFour = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { modelState, setModelState, currentStep, goBack, submitOffer, setters, iban, acceptApplication } =
    useDupFlowContext();

  const submitPaymentDetails = async () => {
    try {
      setLoading(true);
      await submitOffer(props.fields.ThankYouLink.url);
    } catch {
      setLoading(false);
      scrollToFirstValidationMessage();
    }
  };

  const step4Completed = iban && acceptApplication?.offerIsAccepted;

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }

    if (index === 1) {
      goBack(2, props.fields.Step2Path.value);
    }

    if (index === 2) {
      goBack(3, props.fields.Step3Path.value);
    }
  };

  useDidMount(() => {
    if (currentStep !== 4) {
      goBack(1, props.fields.Step3Path.value);
    }
  });

  if (currentStep !== 4) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={3}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
      </StepIndicator>
      <FlowLayout
        Sidebar={
          <DupSummary
            {...props}
            cannotEdit
            submitButtonProps={{
              id: "sendRequestButtonId",
              children: props.fields.SendOfferSubmitButtonText.value,
              loading,
              onClick: submitPaymentDetails,
              disabled: !step4Completed,
            }}
          />
        }
        {...props}
      >
        <ValidationMessage id="global" modelState={modelState} property="Global" />

        <IbanNumber
          fields={props.fields}
          modelState={modelState}
          onUpdateIbanNumber={setters.updateIbanNumber}
          setModelState={setModelState}
          valueIban={iban}
          required
          propertyNameOverride="model.DupApplication.Iban"
        />
        <ClientCheckList
          fields={props.fields}
          onUpdateAcceptCheckbox={setters.updateAcceptCheckbox}
          offerIsAccepted={acceptApplication?.offerIsAccepted ?? false}
        />
      </FlowLayout>
    </>
  );
};
